import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["content", "icon"];

  toggle(event) {
    event.stopPropagation();
    const isExpanded = this.element.getAttribute("aria-expanded") === "true";

    if (isExpanded) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.element.setAttribute("aria-expanded", "true");
    this.contentTarget.classList.remove("hidden");
    this.iconTarget.classList.add("rotate-45");
    // Dispatch an open event to trigger the accordion
    this.dispatch("open");
  }

  close() {
    console.log("close!", this.element);
    this.element.setAttribute("aria-expanded", "false");
    this.contentTarget.classList.add("hidden");
    this.iconTarget.classList.remove("rotate-45");
  }
}
